// extracted by mini-css-extract-plugin
module.exports = {"footer":"Steps_footer__5dJkp","hideSteps":"Steps_hideSteps__3zEhO"};